import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { toast } from "sonner";
import App from "./App.tsx";
import "./index.css";

const CACHE_RESET_KEY = "elfaza-pwa-cache-reset-v3";
const PREVIEW_HOST_MARKERS = ["id-preview--", "lovableproject.com"];

const isPreviewHost = PREVIEW_HOST_MARKERS.some((marker) =>
  window.location.hostname.includes(marker),
);

let updateSW: ((reloadPage?: boolean) => Promise<void>) | undefined;

if ("serviceWorker" in navigator && !isPreviewHost) {
  updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      toast("Mise à jour disponible", {
        description: "Une nouvelle version d'EL FAZA est prête.",
        duration: Infinity,
        action: {
          label: "Recharger",
          onClick: () => {
            void updateSW?.(true);
          },
        },
      });
    },
  });
}

const forceOneTimePwaReset = async () => {
  if (!("serviceWorker" in navigator) || !("caches" in window) || isPreviewHost) return;

  const hasBeenReset = window.localStorage.getItem(CACHE_RESET_KEY) === "1";
  const [registrations, cacheKeys] = await Promise.all([
    navigator.serviceWorker.getRegistrations(),
    caches.keys(),
  ]);

  if (!registrations.length && !cacheKeys.length) {
    window.localStorage.setItem(CACHE_RESET_KEY, "1");
    return;
  }

  if (hasBeenReset) return;

  await Promise.allSettled([
    ...registrations.map((registration) => registration.unregister()),
    ...cacheKeys.map((cacheKey) => caches.delete(cacheKey)),
  ]);

  window.localStorage.setItem(CACHE_RESET_KEY, "1");
  window.location.replace(window.location.href);
};

void forceOneTimePwaReset().finally(() => {
  createRoot(document.getElementById("root")!).render(<App />);

  if ("serviceWorker" in navigator) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }
});
